import { Tag } from 'antd';
import { capitalize } from 'lodash';
import { Link } from 'react-router-dom';
import { linkCell } from 'utils/cell-formatter';
import { formatDateTime } from 'utils/formatDate';

const bankAccountStatusColors = {
  pending: 'orange',
  success: 'green',
  deleting: 'yellow',
  deleted: 'grey',
  failed: 'red',
};

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/investment/bank-accounts' }),
  },
  {
    accessorKey: 'user',
    header: 'User',
    cell: ({ getValue }) => {
      const user = getValue();
      if (!user) return '-';
      return (
        <Link to={`/investment/users/${user.id}`}>
          <div>{user.name}</div>
          <div className="text-xs text-gray-500">{user.email}</div>
        </Link>
      );
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ getValue }) => {
      const value = getValue();
      return value ? (
        <Tag color={bankAccountStatusColors[value] || 'default'}>
          {capitalize(value)}
        </Tag>
      ) : (
        '-'
      );
    },
  },
  {
    accessorKey: 'bank_name',
    header: 'Bank Name',
  },
  {
    accessorKey: 'bank_account_name',
    header: 'Bank Account Name',
  },
  {
    accessorKey: 'bank_account_number',
    header: 'Bank Account Number',
  },
  {
    accessorKey: 'account_number',
    header: 'Account Number',
  },
  {
    accessorKey: 'trading_account_manager',
    header: 'Trading Account Manager',
  },
  {
    accessorKey: 'created_at',
    header: 'Created At',
    cell: ({ getValue }) => formatDateTime(getValue()),
  },
];
